<template>
  <!-- A table row's actions behind a ⋮ button, in the CliqSign documents menu look: a soft-bordered card, labelled rows
       with muted brand outline icons, grouped (view / change / remove) and split by dividers, remove actions in red. -->
  <v-menu location="bottom end">
    <template #activator="{ props: menuProps }">
      <v-btn v-bind="menuProps" icon variant="tonal" color="brand-color" size="x-small" :aria-label="label">
        <v-icon size="16">mdi-dots-vertical</v-icon>
      </v-btn>
    </template>
    <menu-card :min-width="200">
      <template v-for="(group, index) in shownGroups" :key="index">
        <v-divider v-if="index" class="my-1" />
        <menu-item v-for="action in group" :key="action.title" :icon="action.icon" :title="action.title" :danger="action.danger"
          icon-color="brand-color" :tick="false" @click="run(action)" />
      </template>
    </menu-card>
  </v-menu>
</template>

<script setup>
import { computed } from 'vue'
import MenuCard from '@/components/common/MenuCard.vue'
import MenuItem from '@/components/common/MenuItem.vue'

const props = defineProps({
  // Groups of actions, drawn in order with a divider between groups. Each action:
  // { title, icon, onClick? | href? (opens in a new tab), danger?, show? }
  groups: { type: Array, required: true },
  label: { type: String, default: 'More actions' }
})

// Hidden actions (show: false) and groups left empty are dropped.
const shownGroups = computed(() => props.groups
  .map(group => group.filter(action => action.show !== false))
  .filter(group => group.length))

function run(action) {
  if (action.href) window.open(action.href, '_blank', 'noopener')
  else action.onClick?.()
}
</script>
